export const conversionConfig = {
  inviteQrSrc: "/assets/qr/invite.jpg",
  groupQrSrc: "/assets/qr/group.jpg",
  calendarUrl: "https://radar.baoyanwang.com.cn/calendar",
} as const;

export const releaseReady = Boolean(
  conversionConfig.inviteQrSrc && conversionConfig.groupQrSrc,
);
